import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADGroup entity - alias of ADObject
 * Represents Active Directory group objects
 */
export const adGroupEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADGroup', display: 'AD Group' },
  alias: 'ADObject',
};
